var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_vm._t("icon"),_c('span',[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }